import AeMaxPrice from './AeMaxPrice';
import mapFinalCalculation, { RawFinalCalculation } from './mapFinalCalculation';
import mapItem, { RawItem } from './mapItem';
import mapReference, { RawReference } from './mapReference';

export interface RawAeMaxPrice {
	reference: RawReference;
	finalCalculation: RawFinalCalculation;
	products: RawItem[];
	_links: { [key: string]: string };
}

export default function mapAeMaxPrice(aeMaxPrice: RawAeMaxPrice): AeMaxPrice {
	return new AeMaxPrice(
		mapReference(aeMaxPrice.reference),
		mapFinalCalculation(aeMaxPrice.finalCalculation),
		aeMaxPrice.products.map(mapItem),
		aeMaxPrice._links
	);
}
